import { Card, Heading, Icon } from '@frontendmentorio/design-system-v2';

export default function What() {
  return (
    <div className="px-5">
      <div className="container-xl flex flex-col gap-6 tablet:gap-7 tablet:items-center">
        <Heading
          className="leading-tight tablet:max-w-[30ch] tablet:text-center"
          level="1"
          tagName="h2"
        >
          What you can do here
        </Heading>

        <ul className="flex flex-col gap-5 max-w-prose mx-auto w-full tablet:grid tablet:grid-cols-2 tablet:max-w-none desktop:grid-cols-3">
          <Card className="flex flex-col gap-4 p-5" tagName="li">
            <span className="aspect-square bg-blue-100 flex-center rounded-lg w-[4.5rem]">
              <Icon
                className="text-blue-500 text-2xl"
                name="question"
                style="solid"
              />
            </span>

            <Heading level="5" tagName="h3">
              Ask questions
            </Heading>

            <p className="text-neutral-500">
              If you’re stuck or need some help with your code, just ask. Our
              members are happy to share their knowledge and offer advice when
              you need it.
            </p>
          </Card>

          <Card className="flex flex-col gap-4 p-5" tagName="li">
            <span className="aspect-square bg-blue-100 flex-center rounded-lg w-[4.5rem]">
              <Icon className="text-blue-500 text-2xl" name="share" />
            </span>

            <Heading level="5" tagName="h3">
              Share your work
            </Heading>

            <p className="text-neutral-500">
              Show off your projects and get honest feedback from others.
              Sharing your work can help you learn new things and improve with
              each project.
            </p>
          </Card>

          <Card className="flex flex-col gap-4 p-5" tagName="li">
            <span className="aspect-square bg-blue-100 flex-center rounded-lg w-[4.5rem]">
              <Icon className="text-blue-500 text-2xl" name="handshake" />
            </span>

            <Heading level="5" tagName="h3">
              Work on projects together
            </Heading>

            <p className="text-neutral-500">
              Looking for someone to pair up with? You can find others here who
              are interested in working together on our challenges.
            </p>
          </Card>

          <Card className="flex flex-col gap-4 p-5" tagName="li">
            <span className="aspect-square bg-blue-100 flex-center rounded-lg w-[4.5rem]">
              <Icon className="text-blue-500 text-2xl" name="messages" />
            </span>

            <Heading level="5" tagName="h3">
              Talk about web development
            </Heading>

            <p className="text-neutral-500">
              Join in on everyday conversations about web development. Whether
              you’re discussing new ideas or troubleshooting code, it’s all
              welcome here.
            </p>
          </Card>

          <Card className="flex flex-col gap-4 p-5" tagName="li">
            <span className="aspect-square bg-blue-100 flex-center rounded-lg w-[4.5rem]">
              <Icon className="text-blue-500 text-2xl" name="bell" />
            </span>

            <Heading level="5" tagName="h3">
              Stay up to date
            </Heading>

            <p className="text-neutral-500">
              Get the latest news about Frontend Mentor challenges, events, and
              updates. It’s a great way to stay informed about everything that’s
              happening.
            </p>
          </Card>

          <Card className="flex flex-col gap-4 p-5" tagName="li">
            <span className="aspect-square bg-blue-100 flex-center rounded-lg w-[4.5rem]">
              <Icon className="text-blue-500 text-2xl" name="comment-check" />
            </span>

            <Heading level="5" tagName="h3">
              Give your feedback
            </Heading>

            <p className="text-neutral-500">
              We’d love to hear your thoughts. If you have ideas or suggestions
              on how to make our community better, please share them with us.
            </p>
          </Card>
        </ul>
      </div>
    </div>
  );
}
